import React             from "react";
import ReactDOM          from "react-dom";
import { addLocaleData } from "react-intl";
import moment            from "moment";

import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import es from "react-intl/locale-data/es";
import en from "react-intl/locale-data/en";
import "moment/locale/es";

import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";

import Routes           from "./routes/index.js";
import ServiceApollo    from "../src/services/serviceApollo";
import ServiceAxios     from "../src/services/serviceAxios";
import ServiceAndroid   from "../src/services/serviceMovil";
import { ContextStore } from "./store";
import "./helpers/axios";

addLocaleData([...es, ...en]);
moment.locale("es");
moment.updateLocale("es", { week: { dow: 0 } });

ReactDOM.render(<ContextStore 
                    comp={<Routes />} 
                    apollocon={ServiceApollo} 
                    axioscon={ServiceAxios}
                    clientAndroid={ServiceAndroid}
                    />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();